const libraryRouter = [
  {
    path: '/library/:id(\\d+)',
    name: 'LibraryDetail',
    component: () => import('@/views/library/detail')
  }
]
export default libraryRouter



// WEBPACK FOOTER //
// ./src/router/modules/library.js